import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';

const Logo = ({ color, ...props }) => {
  const logoUrl = color === 'white' ? '/images/logo.png' : '/images/logo.png';
  const logoSymbolUrl = color === 'white' ? '/images/logo.png' : '/images/logo.png';

  return (
    <Box className="pointer" {...props}>
      <Hidden xsDown>
        <NavLink to="/">
          <CmtImage src={logoUrl} alt="logo" height="68px" style={{ width: 'auto' }} />
        </NavLink>
      </Hidden>
      <Hidden smUp>
        <NavLink to="/">
          <CmtImage src={logoSymbolUrl} alt="logo" height="68px" style={{ width: 'auto' }} />
        </NavLink>
      </Hidden>
    </Box>
  );
};

export default Logo;
